import { render, staticRenderFns } from "./BrowseColumns.vue?vue&type=template&id=76570706&scoped=true&"
import script from "./BrowseColumns.vue?vue&type=script&lang=js&"
export * from "./BrowseColumns.vue?vue&type=script&lang=js&"
import style0 from "./BrowseColumns.vue?vue&type=style&index=0&id=76570706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76570706",
  null
  
)

export default component.exports